'use strict';
define(['app'], function (app) {
    function ProjectPreviewController($scope, $interval, $timeout, $window) {
        var vm = $scope;
        var destroyed = false;
        var sceneOrder = ['issues', 'fix', 'tracker', 'traffic'];
        var sceneTimers = [];
        var scanTimers = [];

        vm.emptyScene = 'issues';
        vm.emptySceneList = [
            {id: 'issues', icon: 'ti-alert-triangle', key: 'dashboard.overview.previewIssues.title'},
            {id: 'fix', icon: 'ti-tool', key: 'dashboard.overview.previewFix.title'},
            {id: 'tracker', icon: 'ti-chart-line', key: 'dashboard.overview.previewRank.title'},
            {id: 'traffic', icon: 'ti-chart-histogram', key: 'dashboard.overview.previewData.title'}
        ];
        vm.scanPages = 0;
        vm.scanProgress = 0;
        vm.reportScore = 0;
        vm.reportIssues = 0;
        vm.reportPassed = 0;
        vm.trackerAvgPosition = 12;
        vm.trackerProgress = 0;
        vm.trackerEndVisible = false;
        vm.youMarker = {left: 6, top: 75};
        vm.compMarkers = [{left: 6, top: 20}, {left: 6, top: 40}];
        vm.trackerPositionValues = [];
        for (var positionValue = 12; positionValue >= 1; positionValue -= 0.5) {
            vm.trackerPositionValues.push(positionValue % 1 === 0 ? String(positionValue) : positionValue.toFixed(1));
        }
        vm.trackerAvgIndex = 0;
        vm.trackerGained = 0;
        vm.previewCompetitors = [
            {
                name: 'Samsung',
                domain: 'samsung.com',
                color: '#2f90de',
                pts: [[6, 8], [14, 9], [22, 8], [30, 9], [38, 8], [46, 10], [54, 9], [62, 8], [70, 10], [78, 9], [86, 8], [94, 8]]
            },
            {
                name: 'Microsoft',
                domain: 'microsoft.com',
                color: '#8e44ad',
                pts: [[6, 16], [14, 15], [22, 14], [30, 13], [38, 12], [46, 13], [54, 12], [62, 11], [70, 13], [78, 12], [86, 11], [94, 11]]
            }
        ];
        vm.previewYou = {
            name: 'Your Website',
            color: 'var(--sto-color-primary)',
            pts: [
                [3, 26.3], [7.5, 27.4], [12, 25.3], [16.5, 26.7], [21, 20.3], [25.5, 24.6],
                [30, 23.1], [34.5, 24.1], [39, 21.3], [43.5, 22.2], [48, 18.7], [52.5, 19.4],
                [57, 16.5], [61.5, 13.4], [66, 14.2], [70.5, 11.3], [75, 8.5], [79.5, 9.4],
                [84, 6.4], [88.5, 4.3], [93, 2.8], [97, 1.4]
            ]
        };
        vm.previewRankDots = vm.previewYou.pts
            .filter(function (_, index) { return index % 2 === 0; })
            .map(function (point) { return {x: point[0], y: point[1]}; });
        vm.previewFavicon = function (domain) {
            return 'https://www.google.com/s2/favicons?sz=64&domain=' + domain;
        };
        vm.previewSmoothPath = function (pairs) {
            var points = pairs.map(function (pair) { return {x: pair[0], y: pair[1]}; });
            if (points.length < 2) return '';
            var path = 'M' + points[0].x + ' ' + points[0].y;
            for (var index = 0; index < points.length - 1; index++) {
                var p0 = points[index - 1] || points[index];
                var p1 = points[index];
                var p2 = points[index + 1];
                var p3 = points[index + 2] || p2;
                var c1x = p1.x + (p2.x - p0.x) / 6;
                var c1y = p1.y + (p2.y - p0.y) / 6;
                var c2x = p2.x - (p3.x - p1.x) / 6;
                var c2y = p2.y - (p3.y - p1.y) / 6;
                path += ' C' + c1x + ' ' + c1y + ' ' + c2x + ' ' + c2y + ' ' + p2.x + ' ' + p2.y;
            }
            return path;
        };
        vm.previewCurvePoint = function (pairs, t) {
            var points = pairs.map(function (pair) { return {x: pair[0], y: pair[1]}; });
            var count = points.length;
            var segment = Math.min(Math.floor(t), count - 2);
            var fraction = Math.min(Math.max(t - segment, 0), 1);
            var p0 = points[Math.max(segment - 1, 0)];
            var p1 = points[segment];
            var p2 = points[Math.min(segment + 1, count - 1)];
            var p3 = points[Math.min(segment + 2, count - 1)];
            var squared = fraction * fraction;
            var cubed = squared * fraction;
            return {
                x: 0.5 * (2 * p1.x + (-p0.x + p2.x) * fraction +
                    (2 * p0.x - 5 * p1.x + 4 * p2.x - p3.x) * squared +
                    (-p0.x + 3 * p1.x - 3 * p2.x + p3.x) * cubed),
                y: 0.5 * (2 * p1.y + (-p0.y + p2.y) * fraction +
                    (2 * p0.y - 5 * p1.y + 4 * p2.y - p3.y) * squared +
                    (-p0.y + 3 * p1.y - 3 * p2.y + p3.y) * cubed)
            };
        };
        vm.previewAnomalies = [
            {label: 'Title mancanti', state: '', fill: 34},
            {label: 'Errori 404', state: '', fill: 22},
            {label: 'Elementi duplicati', state: '', fill: 28},
            {label: 'Problemi di indicizzazione', state: '', fill: 41},
            {label: 'Immagini senza alt', state: '', fill: 17},
            {label: 'Hreflang', state: '', fill: 51}
        ];

        function cancelTimers(timers) {
            timers.forEach(function (timer) {
                if (timer && timer.cancel) timer.cancel();
            });
            timers.length = 0;
        }

        function resetStories() {
            cancelTimers(sceneTimers);
            cancelTimers(scanTimers);
            vm.scanPages = 0;
            vm.scanProgress = 0;
            vm.reportScore = 0;
            vm.reportIssues = 0;
            vm.reportPassed = 0;
            vm.trackerAvgPosition = 12;
            vm.trackerProgress = 0;
            vm.trackerEndVisible = false;
            vm.trackerAvgIndex = 0;
            vm.trackerGained = 0;
            vm.previewAnomalies.forEach(function (item) { item.state = ''; });
        }

        function runScanCounter() {
            vm.scanPages = 0;
            vm.scanProgress = 0;
            var counter = $interval(function () {
                vm.scanPages = Math.min(vm.scanPages + 2, 78);
                vm.scanProgress = Math.round(vm.scanPages / 78 * 100);
                if (vm.scanPages >= 78) $interval.cancel(counter);
            }, 40);
            scanTimers.push(counter);
        }

        function runScanStory() {
            runScanCounter();
            vm.previewAnomalies.forEach(function (item, index) {
                scanTimers.push($timeout(function () { item.state = 'is-found'; }, 800 + index * 450));
            });
        }

        function runTrackerStory() {
            vm.trackerAvgPosition = 12;
            vm.trackerAvgIndex = 0;
            vm.trackerGained = 0;
            vm.trackerProgress = 0;
            vm.trackerEndVisible = false;
            var youPoints = vm.previewYou.pts;
            var competitorPoints = [vm.previewCompetitors[0].pts, vm.previewCompetitors[1].pts];
            var youStart = vm.previewCurvePoint(youPoints, 0);
            vm.youMarker = {left: youStart.x, top: youStart.y * 2.5};
            vm.compMarkers = competitorPoints.map(function (points) {
                var point = vm.previewCurvePoint(points, 0);
                return {left: point.x, top: point.y * 2.5};
            });

            scanTimers.push($timeout(function () { vm.trackerEndVisible = true; }, 850));
            var labelCounter = $interval(function () {
                vm.trackerAvgPosition = Math.max(Math.round((vm.trackerAvgPosition - 0.5) * 10) / 10, 1);
                vm.trackerAvgIndex = Math.min(
                    Math.round((12 - vm.trackerAvgPosition) * 2),
                    vm.trackerPositionValues.length - 1
                );
                vm.trackerGained = Math.round((12 - vm.trackerAvgPosition) / 11 * 6);
                if (vm.trackerAvgPosition <= 1) $interval.cancel(labelCounter);
            }, 80);
            scanTimers.push(labelCounter);

            var started = Date.now();
            var duration = 2200;
            var reduced = $window.matchMedia &&
                $window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            var counter = $interval(function () {
                var progress = Math.min((Date.now() - started) / duration, 1);
                if (reduced) progress = 1;
                var eased = progress * progress * (3 - 2 * progress);
                vm.trackerProgress = eased * 100;
                var youPoint = vm.previewCurvePoint(youPoints, eased * (youPoints.length - 1));
                vm.youMarker.left = youPoint.x;
                vm.youMarker.top = youPoint.y * 2.5;
                competitorPoints.forEach(function (points, index) {
                    var point = vm.previewCurvePoint(points, eased * (points.length - 1));
                    vm.compMarkers[index].left = point.x;
                    vm.compMarkers[index].top = point.y * 2.5;
                });
                if (progress >= 1) $interval.cancel(counter);
            }, 33);
            scanTimers.push(counter);
        }

        function runFixStory() {
            vm.reportScore = 54;
            vm.reportIssues = 48;
            vm.reportPassed = 0;
            vm.previewAnomalies.slice(0, 4).forEach(function (item, index) {
                scanTimers.push($timeout(function () { item.state = 'is-fixed'; }, 250 + index * 480));
            });
            var started = Date.now();
            var duration = 2600;
            var counter = $interval(function () {
                var progress = Math.min((Date.now() - started) / duration, 1);
                var eased = progress * progress * (3 - 2 * progress);
                vm.reportScore = Math.round(54 + 38 * eased);
                vm.reportIssues = Math.round(48 * (1 - eased));
                vm.reportPassed = Math.round(33 * eased);
                if (progress >= 1) $interval.cancel(counter);
            }, 40);
            scanTimers.push(counter);
        }

        function showScene(index) {
            if (destroyed) return;
            vm.emptyScene = sceneOrder[index % sceneOrder.length];
            cancelTimers(scanTimers);
            vm.previewAnomalies.forEach(function (item) { item.state = ''; });
            if (vm.emptyScene === 'issues') runScanStory();
            if (vm.emptyScene === 'fix') runFixStory();
            if (vm.emptyScene === 'tracker') runTrackerStory();
            var duration = {issues: 5600, fix: 3800, tracker: 3400, traffic: 4800}[vm.emptyScene] || 3400;
            sceneTimers.push($timeout(function () { showScene(index + 1); }, duration));
        }

        this.$onInit = function () {
            showScene(0);
        };

        this.$onDestroy = function () {
            destroyed = true;
            resetStories();
        };
    }

    ProjectPreviewController.$inject = ['$scope', '$interval', '$timeout', '$window'];

    app.component('stProjectPreview', {
        templateUrl: 'app/components/st-project-preview/st-project-preview.component.html',
        controller: ProjectPreviewController
    });
});
